var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadSub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.899,
    height: 14.982,
    viewBox: "0 0 8.899 14.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(.1 .109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_340",
    "data-name": "Vrstva 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_211",
    fill: "#8b8c8c",
    fillRule: "evenodd",
    stroke: "#f7f8f9",
    strokeWidth: "0.2px",
    d: "M9.895 15.729a4.719 4.719 0 0 0 3.8-4.867V5.124a.623.623 0 1 0-1.242 0v5.919a3.455 3.455 0 0 1-1.142 2.594 2.941 2.941 0 0 1-2.585.687 3.394 3.394 0 0 1-2.485-3.408V4.347A2.074 2.074 0 0 1 6.917 2.8a1.767 1.767 0 0 1 1.537-.427 2.051 2.051 0 0 1 1.515 2.075V9.7a.623.623 0 1 1-1.242 0V5.686a.623.623 0 1 0-1.242 0V9.7a2.078 2.078 0 0 0 .662 1.571 1.768 1.768 0 0 0 1.549.437A2.046 2.046 0 0 0 11.211 9.6V4.347a3.455 3.455 0 0 0-1.141-2.594 2.941 2.941 0 0 0-2.585-.687A3.394 3.394 0 0 0 5 4.474v6.568a4.857 4.857 0 0 0 1.46 3.541 4.143 4.143 0 0 0 3.435 1.146z",
    "data-name": "Trazado 211",
    transform: "translate(-4.999 -.999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSub);
export default __webpack_public_path__ + "static/media/upload-sub.fecacebd.svg";
export { ForwardRef as ReactComponent };